import BaseService from "../baseService";
class DespesaCnpj extends BaseService {
  constructor(id) {
    const resource = "cnpj-despesa";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new DespesaCnpj(id);
